import { IllegalStateError } from "shared-ts-utils-core";
import { NullableSettingConfig } from "./NullableSettingConfig";

export const NullableBooleanSetting: NullableSettingConfig<boolean | null> = {
  type: "boolean",
  serialize: (value: boolean | null): string | null => {
    if (value == null) {
      return null;
    }
    return value ? "true" : "false";
  },

  deserialize: (value: string | null): boolean | null => {
    if (value == null) {
      return null;
    } else if (value === "true") {
      return true;
    } else if (value === "false") {
      return false;
    } else {
      throw new IllegalStateError(
        "Deserialized value of a boolean is illegal: " + value
      );
    }
  },
};
